<template>
  <div class="comp-login-form">
    <div class="login-form" id="loginForm">
      <p class="f20 mb30">用户登录</p>
      <a v-if="showClose" href="javascript:" class="close-btn" @click="$emit('close-click')"><i
        class="iconfont iconcuohao"></i></a>
      <el-form ref="loginForm" :model="loginForm">
        <el-form-item>
          <el-input placeholder="手机号/用户名" v-model="loginForm.userName"></el-input>
        </el-form-item>
        <el-form-item class="mb10">
          <el-input type="password" placeholder="密码" v-model="loginForm.password"
                    @keyup.enter.native="submitLogin"></el-input>
        </el-form-item>
        <el-form-item class="mb10">
          <!--<el-checkbox v-model="saveAccount" @change="bindSaveAccountChange" class="text-color-3">记住账号</el-checkbox>-->
          <span>没有账户？<span style="text-decoration: underline" @click="bindReg" class="cur-poi">立即注册</span></span>
          <span @click="bindFindPwd" class="text-primary fr cur-poi">忘记密码?</span>
        </el-form-item>
        <el-form-item>
          <el-button @click="submitLogin" type="primary" size="big" class="btn-block btn-login">登录</el-button>
        </el-form-item>
        <tx-end-line text="使用合作账号登录"/>
        <p class="tc mt15" v-if="qqLoginEnable"><img class="qq-login cur-poi" @click="bindQQLogin"
                                                     src="../assets/icon/qq-login.png" alt="qq-login"></p>
      </el-form>
    </div>
  </div>
</template>

<script>
  /*!*
   * @author shaojingchao
   * @date 2019/9/29
   * @project zujuanzaixian
   * @desc
   */
  import { loginApi, oauthQQLoginApi } from '../api/login'
  import { mapGetters } from 'vuex'
  import { LOADING_CONFIG, SAVE_ACCOUNT_ACTIVE_KEY, USER_ACCOUNT_KEY } from '../config'
  import { Loading } from 'element-ui'
  import { MixinMetaInfo } from '../mixins/meta-info'
  import { getLocalItem, removeLocalItem, setLocalItem } from '../utils/storage'
  import { loginCBMixin } from '../mixins/login-callback'

  export default {
    name: 'comp-login-form',
    mixins: [MixinMetaInfo, loginCBMixin],
    props: {
      isDialog: Boolean,
      showClose: Boolean
    },
    data () {
      return {
        saveAccount: false,
        qqLoginEnable: true,
        loginForm: {
          userName: '',
          password: ''
        }
      }
    },
    computed: {
      ...mapGetters('common', ['currentSubject', 'subjectList']),
      isComplete () {
        let form = this.loginForm
        return form.username && form.password
      }
    },
    created () {
      this.loginForm.userName = getLocalItem(USER_ACCOUNT_KEY) || ''
      this.saveAccount = getLocalItem(SAVE_ACCOUNT_ACTIVE_KEY) || false
    },
    methods: {
      bindSaveAccountChange (val) {
        setLocalItem(SAVE_ACCOUNT_ACTIVE_KEY, val)
        if (val) {
          setLocalItem(USER_ACCOUNT_KEY, this.loginForm.userName)
        } else {
          removeLocalItem(USER_ACCOUNT_KEY)
        }
      },
      submitLogin () {
        let vm = this
        let form = vm.loginForm
        if (!form.userName) {
          vm.$message.warning('帐号不能为空！')
          return false
        }
        if (!form.password) {
          vm.$message.warning('密码不能为空！')
          return false
        }
        loginApi(form, { loading: '#loginForm' }).then((data) => {
          if (vm.saveAccount) {
            setLocalItem(USER_ACCOUNT_KEY, form.userName)
          }
          this.loginCB(data)

          // 单页需要跳转
          if (this.isDialog) {
            return
          }
          let from = vm.$route.query.from || '/'
          let loading = Loading.service(Object.assign({}, LOADING_CONFIG, { text: '页面跳转中，请稍候...' }))
          vm.$router.replace(from, () => {
            loading.close()
          }, () => {
            vm.$message.error('sorry,加载失败 -_-!')
            loading.close()
          })
        })
      },
      // 去注册
      bindReg () {
        if (this.isDialog) {
          this.$emit('should-close')
        }
        this.$router.push({ name: 'Register' })
      },
      // 忘记密码
      bindFindPwd () {
        if (this.isDialog) {
          this.$emit('should-close')
        }
        this.$router.push({ name: 'FindPassword' })
      }
    }
  }
</script>

<style lang="less">
  @import "../styles/_mixins-wln";

  .comp-login-form {
    .login-form {
      position: relative;
      width: 340px;
      background-color: #fff;
      border-radius: 3px;
      padding: 30px;

      .close-btn {
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        font-size: 20px;
        position: absolute;
        right: -45px;
        top: -8px;
      }

      .btn-login {
        width: 100%;
      }
    }
  }
</style>
